/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import TableCell from "../../../components/TableCell";

export const TABLE_COLUMNS = [
  {
    Header: "Category",
    accessor: "ProductCategory.CodeDescription",
    id: "ProductCategory"
  },
  {
    Header: "Code",
    accessor: "ProductCode",
    id: "ProductCode"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "UOM",
    accessor: "ProductUOM.CodeDescription",
    id: "ProductUOM"
  },
  {
    Header: "Order",
    accessor: "ListOrder",
    id: "ListOrder"
  },
  {
    Header: "Active",
    accessor: "Active",
    id: "Active"
  },
  {
    Header: "Group",
    accessor: "ProductGroup.CodeDescription",
    id: "ProductGroup"
  },
  {
    Header: "Hazmat",
    accessor: "HazmatCode",
    id: "HazmatCode"
  },
  {
    Header: "GL Revenue Number",
    accessor: "RevGL.MainAccountId",
    id: "RevGLMainAccountId"
  },
  {
    Header: "GL Revenue Account",
    accessor: "RevGL.Description",
    id: "RevGL"
  },
  {
    Header: "Fee Calculation Type",
    accessor: "CalcType.CodeDescription",
    id: "CalcType"
  },
  {
    Header: "Price",
    accessor: "Price",
    id: "Price",
    Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
  },
  {
    Header: "%",
    accessor: "Percentage",
    id: "Percentage",
    Cell: ({ cell }) => <TableCell.Percent value={cell.value} />
  },
  {
    Header: "Mandatory Fee",
    accessor: "Mandatory",
    id: "Mandatory"
  },
  {
    Header: "Note",
    accessor: "Note",
    id: "Note"
  }
];

export const EXPORT_COLUMNS = [
  {
    Header: "Category",
    accessor: "ProductCategory.CodeDescription",
    id: "ProductCategory"
  },
  {
    Header: "Code",
    accessor: "ProductCode",
    id: "ProductCode"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "UOM",
    accessor: "ProductUOM.CodeDescription",
    id: "ProductUOM"
  },
  {
    Header: "Active",
    accessor: "Active",
    id: "Active"
  },
  {
    Header: "Group",
    accessor: "ProductGroup.CodeDescription",
    id: "ProductGroup"
  },
  {
    Header: "Hazmat",
    accessor: "HazmatCode",
    id: "HazmatCode"
  },
  {
    Header: "GL Revenue Number",
    accessor: "RevGL.MainAccountId",
    id: "RevGLMainAccountId"
  },
  {
    Header: "GL Revenue Account",
    accessor: "RevGL.Description",
    id: "RevGL"
  },
  {
    Header: "Fee Calculation Type",
    accessor: "CalcType.CodeDescription",
    id: "CalcType"
  },
  {
    Header: "Price",
    accessor: "Price",
    id: "Price",
    Cell: ({ cell }) => `$ ${cell.value.toFixed(2)}`
  },
  {
    Header: "%",
    accessor: "Percentage",
    id: "Percentage"
  },
  {
    Header: "Mandatory Fee",
    accessor: "Mandatory",
    id: "Mandatory"
  },
  {
    Header: "Note",
    accessor: "Note",
    id: "Note"
  }
];
